import { friendlyPhoneFormat } from '@provision/chat-utils';
import { getFullName } from '@provision/formatting-utils';
import type { ClientRaw } from 'src/types';
import { Client } from './client.types';

export function mapClients(clients?: ClientRaw[]) {
  return clients?.map((client) => mapClient(client));
}

// TODO: migrate those transformations to packages/graphql-client/src/useGraphQLProviderConfig.ts
export function mapClient(client: ClientRaw) {
  return {
    ...client,
    fullName: getFullName(client),
    primaryEmail: client.primaryEmail?.value,
    primaryClientEmailId: client.primaryEmail?.id,
    primaryEmailLabelId: client.primaryEmail?.labelId,
    primaryPhoneNumber: friendlyPhoneFormat(client.primaryPhoneNumber?.value),
    primaryClientPhoneNumberId: client.primaryPhoneNumber?.id,
    primaryPhoneNumberLabelId: client.primaryPhoneNumber?.labelId,
    marketingOptOut: client.marketingOptOut ?? false,
    phoneNumbers: client.phoneNumbers?.map((phoneNumber) => ({
      id: phoneNumber.id,
      clientPhoneNumberId: phoneNumber.clientPhoneNumberId,
      number: phoneNumber.value,
      labelId: phoneNumber.labelId,
      smsOptOut: phoneNumber.smsOptOut,
    })),
    emails: client.emails?.map((email) => ({
      id: email.id,
      clientEmailId: email.clientEmailId,
      email: email.value?.toString(),
      labelId: email.labelId,
    })),
  } as Client;
}
